import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const classificationgroups = 
{
    namespaced: true,
    state: {
        classificationgroups: [],
        classificationgroup: {}
    },
    mutations: {
        SET_CLASSIFICATIONGROUPS(state, data)
        {
            state.classificationgroups = data
        },
        SET_CLASSIFICATIONGROUP(state, data)
        {
            state.classificationgroup = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios 
          .get(baseUrl+'GHSClassificationGroups', { withCredentials: true })
          .then(res => {
              console.log(res.data);
              commit('SET_CLASSIFICATIONGROUPS', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deleteClassificationGroup ({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id, { withCredentials: true })
            .catch(error => console.log(error))
          },
          updateClassificationGroup({ commit }, {id, data}){
            return axios
            .post(baseUrl+'GHSClassificationGroups/updateClassificationGroup/' + id, data, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getClassificationGroup ({ commit },id) {
            return axios
            .get(baseUrl+'GetVendor?vendorId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_VENDOR', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewClassificationGroup ({ commit }, data) {
            return axios
            .post(baseUrl+'GHSClassificationGroups/addClassificationGroup', data, { withCredentials: true }, {
                headers: {
                    'Content-Type': 'application/json'
                    // You can add more headers if needed
                }
            })
            
            .then(res => {
                console.log("Classification Groupe Added:" , res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default classificationgroups